var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        [
          _c(
            "Subheader",
            { attrs: { "no-search": "", title: "Details" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { light: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showSetAsAliasDialog()
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-1", attrs: { color: "warning" } },
                    [_vm._v("call_merge")]
                  ),
                  _vm._v("Demote to Alias\n      "),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-subheader",
                { staticClass: "subheading", attrs: { "one-line": "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "primary--text",
                      staticStyle: { width: "200px" },
                    },
                    [_c("strong", [_vm._v("Analyte Name:")])]
                  ),
                  _vm._v(" "),
                  !_vm.isEdit
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.analyteData ? _vm.analyteData.AnalyteName : ""
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("v-text-field", {
                        model: {
                          value: _vm.editAnalyte.AnalyteName,
                          callback: function ($$v) {
                            _vm.$set(_vm.editAnalyte, "AnalyteName", $$v)
                          },
                          expression: "editAnalyte.AnalyteName",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-subheader",
                { staticClass: "subheading", attrs: { "one-line": "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "primary--text",
                      staticStyle: { width: "200px" },
                    },
                    [_c("strong", [_vm._v("Display Name:")])]
                  ),
                  _vm._v(" "),
                  !_vm.isEdit
                    ? _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.analyteData ? _vm.analyteData.DisplayName : ""
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("v-text-field", {
                        model: {
                          value: _vm.editAnalyte.DisplayName,
                          callback: function ($$v) {
                            _vm.$set(_vm.editAnalyte, "DisplayName", $$v)
                          },
                          expression: "editAnalyte.DisplayName",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-subheader",
                { staticClass: "subheading" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "primary--text",
                      staticStyle: { width: "200px" },
                    },
                    [_c("strong", [_vm._v("Applicable Unit Group:")])]
                  ),
                  _vm._v(" "),
                  !_vm.isEdit
                    ? _c("div", [
                        _vm._v(
                          _vm._s(_vm.analyteData ? _vm.unitGroupNameById : "") +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("v-autocomplete", {
                        attrs: {
                          items: _vm.allUnitGroups,
                          "item-text": "Name",
                          "return-object": "",
                        },
                        on: { change: _vm.changeUnitGroup },
                        model: {
                          value: _vm.unitGroup,
                          callback: function ($$v) {
                            _vm.unitGroup = $$v
                          },
                          expression: "unitGroup",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-subheader",
                { staticClass: "subheading" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "primary--text",
                      staticStyle: { width: "200px" },
                    },
                    [_c("strong", [_vm._v("Default Unit:")])]
                  ),
                  _vm._v(" "),
                  !_vm.isEdit
                    ? _c("div", [
                        _vm._v(_vm._s(_vm.analyteData ? _vm.unitNameById : "")),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("v-autocomplete", {
                        attrs: {
                          items: _vm.unitGroup ? _vm.unitGroup.Units : [],
                          "item-text": "Name",
                          "return-object": "",
                        },
                        model: {
                          value: _vm.unit,
                          callback: function ($$v) {
                            _vm.unit = $$v
                          },
                          expression: "unit",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              !_vm.isEdit
                ? _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.edit(_vm.analyteData)
                        },
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { color: "warning" } },
                        [_vm._v("edit")]
                      ),
                      _vm._v(_vm._s(_vm.$t("Button.Edit")) + "\n      "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEdit
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.checkUnitGroup()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isEdit
                ? _c(
                    "v-btn",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("AnalyteDetailInformation.titleMsg1", {
                        msg: _vm.linkToGlobalRequestParameter.AnalyteName,
                      })
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("AnalyteDetailInformation.alertMsg")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _vm.ableToSetAsAlias
                  ? _c("v-text-field", {
                      attrs: { readonly: "", label: "Alias name" },
                      model: {
                        value: _vm.linkToGlobalRequestParameter.AnalyteName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.linkToGlobalRequestParameter,
                            "AnalyteName",
                            $$v
                          )
                        },
                        expression: "linkToGlobalRequestParameter.AnalyteName",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.ableToSetAsAlias
                  ? _c("v-text-field", {
                      attrs: { label: "Method" },
                      model: {
                        value: _vm.method,
                        callback: function ($$v) {
                          _vm.method = $$v
                        },
                        expression: "method",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("v-autocomplete", {
                  attrs: {
                    items: _vm.analyteListExceptByAnalyte,
                    label: "Target analyte",
                    "item-text": "AnalyteName",
                    "return-object": "",
                  },
                  model: {
                    value: _vm.linkToGlobalRequestParameter.TargetAnalyte,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.linkToGlobalRequestParameter,
                        "TargetAnalyte",
                        $$v
                      )
                    },
                    expression: "linkToGlobalRequestParameter.TargetAnalyte",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success", dark: "" },
                    on: {
                      click: function ($event) {
                        return _vm.submitLinkToGlobalRequest()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Submit")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.linkToGlobalRequestDialog,
          callback: function ($$v) {
            _vm.linkToGlobalRequestDialog = $$v
          },
          expression: "linkToGlobalRequestDialog",
        },
      }),
      _vm._v(" "),
      _c("AppConfirmationModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("AnalyteDetailInformation.differentTitle", {
                        link: _vm.pluralize(
                          "link",
                          _vm.differentStandards.length
                        ),
                      })
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  {
                    attrs: { type: "warning", outline: "" },
                    model: {
                      value: _vm.differentUnitGroupModel,
                      callback: function ($$v) {
                        _vm.differentUnitGroupModel = $$v
                      },
                      expression: "differentUnitGroupModel",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("AnalyteDetailInformation.differentMsg", {
                            msg: _vm.differentStandardsName,
                            link: _vm.pluralize(
                              "link",
                              _vm.differentStandards.length
                            ),
                            guideline: _vm.pluralize(
                              "guideline",
                              _vm.differentStandards.length
                            ),
                          })
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success", dark: "" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Update_Anyway")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        _vm.cancel()
                        _vm.differentUnitGroupModel = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.differentUnitGroupModel,
          callback: function ($$v) {
            _vm.differentUnitGroupModel = $$v
          },
          expression: "differentUnitGroupModel",
        },
      }),
      _vm._v(" "),
      _c("AppConfirmationModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "AnalyteDetailInformation.affectAnalyteCofactorTitle"
                      )
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  {
                    attrs: { type: "warning", outline: "" },
                    model: {
                      value: _vm.affectAnalyteCofactorModel,
                      callback: function ($$v) {
                        _vm.affectAnalyteCofactorModel = $$v
                      },
                      expression: "affectAnalyteCofactorModel",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "AnalyteDetailInformation.affectAnalyteCofactorMsg",
                            {
                              msg: _vm.affectAnalyteCofactorMapping,
                              link: _vm.pluralize(
                                "link",
                                _vm.affectAnalyteCofactor.length
                              ),
                              cofactor: _vm.pluralize(
                                "cofactor",
                                _vm.affectAnalyteCofactor.length
                              ),
                            }
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success", dark: "" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Update_Anyway")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        _vm.cancel()
                        _vm.affectAnalyteCofactorModel = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.affectAnalyteCofactorModel,
          callback: function ($$v) {
            _vm.affectAnalyteCofactorModel = $$v
          },
          expression: "affectAnalyteCofactorModel",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: { color: _vm.snackColor, top: "", "auto-height": "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }